import React, { ReactNode, useMemo } from 'react';
import { Logger, LoggerConfig } from '../utils/logger';
import { getLoggerConfig } from '../config/logger.config';
import { LoggerContext, LoggerContextType } from './LoggerContext';

interface LoggerProviderProps {
  children: ReactNode;
  config?: LoggerConfig;
}

export const LoggerProvider: React.FC<LoggerProviderProps> = ({
  children,
  config,
}) => {
  const loggerInstance = useMemo(() => {
    const loggerConfig = config || getLoggerConfig();
    return new Logger(loggerConfig);
  }, [config]);

  const contextValue: LoggerContextType = useMemo(
    () => ({
      logger: loggerInstance,
    }),
    [loggerInstance]
  );

  return (
    <LoggerContext.Provider value={contextValue}>
      {children}
    </LoggerContext.Provider>
  );
};
